// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3WSra","buttons":"PendingPaymentAlert_buttons__2TQUU"};